module.exports = __webpack_public_path__ + "static/img/6.22747022.jpg";